import { setGlobalStyle } from '@styles/setGlobalStyle';
import { IhomepageSetting } from '@typings/setting/homepageSetting.interface';
import { CARD_BORDER_TYPE } from '@typings/setting/cardBorderType';
import { homepageDefaultSetting } from '@constants/homepageDefaultSetting';
import { formatPixelValue } from '../utils/formatPixelValue';

function mainSetting(homeSet: IhomepageSetting) {
  const { logoImgURL } =
    homeSet.homepageSet || homepageDefaultSetting.homepageSet;

  const {
    backgroundColor,
    backgroundColor2,
    backgroundGradientDir,
    backgroundImgURL,
    showBackgroundImage,
  } =
    homeSet.background || homepageDefaultSetting.background;
  const { font, button, primary, card, menu } =
    homeSet || homepageDefaultSetting;
  const getMeaningfulFont = (value?: string) => {
    if (typeof value !== 'string') return '';
    return value.trim();
  };
  const resolvedMenuFontFamily =
    getMeaningfulFont(menu.menuFontFamily) ||
    getMeaningfulFont(font.headerFontFamily) ||
    getMeaningfulFont(font.defaultFontFamily);

  // logo
  document.documentElement.style.setProperty(
    `--logoImgURL`,
    `url('${logoImgURL}')`,
  );

  // background
  // showBackgroundImage가 false이면 배경 이미지를 숨김 (기본값 true)
  const shouldShowBackgroundImage = showBackgroundImage !== false;
  const finalBackgroundImgURL = shouldShowBackgroundImage ? backgroundImgURL : '';

  setGlobalStyle(
    'backgroundImgURL',
    finalBackgroundImgURL ? `url('${finalBackgroundImgURL}')` : 'none',
  );
  // 단색 배경색 (그라디언트 없이) - linear-gradient 내부에서 사용할 때 필요
  setGlobalStyle('backgroundColorSolid', backgroundColor);

  const bgValue =
    backgroundColor2 && backgroundColor2 !== ''
      ? `linear-gradient(${backgroundGradientDir || '135deg'}, ${backgroundColor} 0%, ${backgroundColor2} 100%)`
      : backgroundColor;
  setGlobalStyle('backgroundColor', bgValue);

  // menu
  setGlobalStyle('menuBackgroundColor', menu.menuBackgroundColor);
  setGlobalStyle('menuGap', menu.menuGap || '8px');
  setGlobalStyle('menuTextColor', menu.menuTextColor || font.textColor);
  setGlobalStyle('menuFontFamily', resolvedMenuFontFamily);
  document.documentElement.style.setProperty(
    `--menuImgURL`,
    `url('${menu.imgURL}')`,
  );
  // 각 메뉴 이미지 최대 높이: 값이 없거나 0이면 기본 80px
  const rawMenuImgMaxHeight = (menu as any).menuImgMaxHeight;
  const formattedMenuImgMaxHeight = rawMenuImgMaxHeight
    ? formatPixelValue(rawMenuImgMaxHeight, '0')
    : '0';
  const isZeroHeight = !rawMenuImgMaxHeight || formattedMenuImgMaxHeight === '0' || formattedMenuImgMaxHeight === '0px' || formattedMenuImgMaxHeight === '0rem' || formattedMenuImgMaxHeight === '0em';
  const menuImgMaxHeightValue = isZeroHeight ? '80px' : formattedMenuImgMaxHeight;
  setGlobalStyle('menuImgMaxHeight', menuImgMaxHeightValue);

  // button
  setGlobalStyle('buttonBackgroundColor', button.buttonBackgroundColor);
  setGlobalStyle('buttonTextColor', button.buttonTextColor);
  setGlobalStyle('buttonBorderRadius', button.buttonBorderRadius);
  // corner-shape (experimental)
  if ((button as any).buttonCornerShape) {
    setGlobalStyle('buttonCornerShape', (button as any).buttonCornerShape);
  }
  // button border image (항시 패치)
  setGlobalStyle(
    'buttonBorderImgURL',
    button.buttonBorderImage ? `url('${button.buttonBorderImage}')` : 'none',
  );
  setGlobalStyle(
    'buttonImgBorderWidth',
    `${formatPixelValue(button.buttonBorderWidth || 0)}`,
  );
  setGlobalStyle('buttonBorderOffset', `${button.buttonBorderOffset || 0}`);
  // color
  setGlobalStyle('primaryColor', primary.primaryColor);
  setGlobalStyle('subColor', primary.subColor);
  setGlobalStyle('inkColor', primary.inkColor);
  setGlobalStyle('lineColor', primary.lineColor);
  // card
  setGlobalStyle('cardLineColor', card.cardLineColor);
  setGlobalStyle('cardBackgroundColor', card.cardBackgroundColor);
  setGlobalStyle('cardBorderRadius', card.cardBorderRadius);
  setGlobalStyle('cardBlur', formatPixelValue(card.cardBlur || '4px'));
  // corner-shape (experimental)
  if ((card as any).cardCornerShape) {
    setGlobalStyle('cardCornerShape', (card as any).cardCornerShape);
  }
  setGlobalStyle(
    'cardBorderImage',
    card.cardBorderImage ? `url('${card.cardBorderImage}')` : 'none',
  );

  setGlobalStyle(
    'cardBorderWidth',
    `${formatPixelValue(card.cardBorderWidth || '1px')}`,
  );
  setGlobalStyle(
    'cardBorderWithImgWidth',
    card.cardBorderImage
      ? '0px'
      : `${formatPixelValue(card.cardBorderWidth || '1px')}`,
  );

  setGlobalStyle('cardBorderOffset', card.cardBorderOffset);
  setGlobalStyle(
    'cardBorderType',
    card.cardBorderType || CARD_BORDER_TYPE.SOLID,
  );
  // text
  setGlobalStyle('textSize', font.textSize);
  setGlobalStyle('textColor', font.textColor);
  setGlobalStyle('subTextColor', font.subTextColor);

  //font
  setGlobalStyle('headerFontFamily', font.headerFontFamily);
  setGlobalStyle('defaultFontFamily', font.defaultFontFamily);
}

export default mainSetting;
